import React, {
	Component
} from 'react';
import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Preloader } from './Preloader';
import { ButtonMover } from './Buttons';
import { integration } from '../integration';
import { i18n } from '../i18n';
import { Sprite } from './Sprite';
import {history} from '../history';
import { Login } from './Login';
import { B64Image } from './B64Image';
import { AvaRules } from './AvaRules';

const Body = styled.div`
	display: flex;
	width: 100vw;
	height: 100vh;
	background-image: url('/assets/splash/${store.isHardRock ? 'splash_bg_HR' : 'splash_bg'}.jpg');
	background-size: cover;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 3vw;
	overflow: hidden;
	letter-spacing: normal;
	font-weight: normal;
	& .continue-install {
		width: 60vw;
		@media (min-aspect-ratio: 9/15){
			width: 50vw;
		}
	}
`

const Content = styled.div`
	flex:2 2 50vh;
	display: flex;
	justify-content: center;
	align-items: center;
`

const LogoBox = styled.div`
	flex: 2 2 50vh;
	justify-content: center;
	@media (min-aspect-ratio: 9/15){
		flex-basis: 20vh;
	}
`
const Logo = styled(B64Image)`
	width: 90vw;
	margin-top: 10vw;
`

const Copy = styled.div`
	color: white;
	font-size: 3vw;
	font-weight: normal;
	white-space: pre-wrap;
    text-align: center;
`

const AcceptTerms = styled.div`
	text-align: center;
	color: white;
	font-size: 4vw;
	text-shadow: 0.5vw 0.5vw 0.5vw #26387a, -0.5vw -0.5vw 0.5vw #26387a, 0.5vw -0.5vw 0.5vw #26387a, -0.5vw 0.5vw 0.5vw #26387a;
	flex-grow: 1;
	display: flex;
	justify-content: flex-end;
	flex-direction: column;
`

const PolicyUpdate = styled.div`
	margin-top: 4vh;
	& a {
		color: #a1ff00;
		text-shadow: 0.3vw 0.3vw 0.1vw #24377b, -0.3vw -0.3vw 0.1vw #24377b, 0.3vw -0.3vw 0.1vw #24377b, -0.3vw 0.3vw 0.1vw #24377b;
	}
`

const ToSLink = styled.span`
	color: #a1ff00;
	cursor: pointer;
	text-shadow: 0.3vw 0.3vw 0.1vw #24377b, -0.3vw -0.3vw 0.1vw #24377b, 0.3vw -0.3vw 0.1vw #24377b, -0.3vw 0.3vw 0.1vw #24377b;
`

const ToSBody = styled.div`
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: column;
	z-index: 5000;
`

const IFrameCloseBtn = styled.button`
	background-color: black;
	color: white;
	padding: 3vw;
	flex: 0 0 3vw;
`

const ToSFrame = styled.iframe`
	flex-grow: 1;
`

@observer
export class Splash extends Component {
	splashEventSent = false;

	constructor(props){
		super(props);
		//the user has previously accepted a TOS but restarted so they have not seen or skipped tutorial
		if(localStorage.getItem('acceptedTosId') !== null && !localStorage.getItem('skippedTutorial')){
			console.log('wrapperstorage tutorial mode start' + localStorage.getItem('acceptedTosId') + localStorage.getItem('skippedTutorial'))
			history.push('/game/intro/play');
		}
	}

	componentWillUnmount(){
		clearTimeout(this.timeout);
		window.setPersistentStorage('welcomeBack',true);
		if(!store.user.hasSeenOrSkippedTutorial){
			store.showTutorialCompleteBubble = true;
		}
	}

	@observable inProgress = false;
	timeout = 0;

	openProfile = () => {
		store.showProfile = true;
	}

	linkAppleSignIn(){
		window.manager.playAudio("poopPop");
		this.inProgress = true;
		this.timeout = setTimeout(() => this.inProgress = false, 2000);
		integration.postAnalyticsEvent('press_Apple_Login', 'ftue');
		if(store.user.appleId){
			store.user.loginMethod = 'apple';
		} else {
			window.WrapperApp.postMessage('apple-login');
		}
	}

	linkFacebook(){
		window.manager.playAudio("poopPop");
		this.inProgress = true;
		this.timeout = setTimeout(() => this.inProgress = false, 2000);
	 	integration.postAnalyticsEvent('press_FB_Connect', 'ftue');
		window.WrapperApp.postMessage('fblogin');
	}

	acceptTerms(){
		// if(store.phaserReady)
		if(!store.oneTurnGame && !localStorage.getItem('hasSeenTutorial')){
			history.push('/game/intro/play');
		}
		window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent('press_continue_accept_terms', 'ftue');
		window.setPersistentStorage('acceptedTosId', store.currentTosId);
		store.acceptedTosId = store.currentTosId;
	}

	confirmGuest() {
		// if(store.phaserReady)
		integration.postAnalyticsEvent('press_play_as_guest', 'ftue');
		window.manager.playAudio("poopPop");
		this.inProgress = true;
		this.timeout = setTimeout(() => this.inProgress = false, 2000);
		store.user.loginConfirmed = true;
	}

	state = {
		preloading: true,
		iframe: ""
	};

	render(){
		const currentTosIdIsKnown = store.currentTosId !== -1;

		if(this.state.iframe){
			return(
				<ToSBody>
					<IFrameCloseBtn onClick={() => { window.manager.playAudio("poopPop"); this.setState({iframe: ""})}}>{i18n.t("Close")}</IFrameCloseBtn>
					<ToSFrame title="terms" src={this.state.iframe}/>
				</ToSBody>
			);
		}

		var content;
		if(this.inProgress){
			content = (
				<div></div>
			);
		} else if(store.preloading){
			content = (
				<Preloader/>
			);
		} else if(store.firstTimeRules) {
			content = (
				<AvaRules/>
			)
			return (
				<Body>
					<Content>
						{content}
					</Content>
					<Copy>{i18n.t('copyright')}</Copy>
				</Body>
			)
		} else {
			if(currentTosIdIsKnown){
				if(!store.tosIsAccepted){
					if(!this.splashEventSent) {
						integration.postAnalyticsEvent('ftue_continue_screen_loaded', 'ftue');
						this.splashEventSent = true;
					}
					content = (
						<AcceptTerms>
							<ButtonMover onClick={this.acceptTerms}>
								<Sprite className="continue-install" sprite="btn_splash_continue.png" path="/assets/languages/" localize/>
							</ButtonMover>
							<PolicyUpdate>
								{i18n.t("updated-policies")}
								<p>
									{/* By continuing to play, you agree to our Terms of Service and our Privacy Policy<br/> */}
									{i18n.t("continue-agreement")}<br/>
									<ToSLink onClick={() => {
										window.manager.playAudio("poopPop");
										integration.postAnalyticsEvent('tos_view', 'ftue');
										this.setState({iframe: "/tos.html"})
									}}>
										{i18n.t("Terms of Service")}
									</ToSLink> {i18n.t("and our")} <ToSLink onClick={() => {
										window.manager.playAudio("poopPop");
										integration.postAnalyticsEvent('pp_view', 'ftue');
										this.setState({iframe: "/pp.html"})
									}}>
										{i18n.t("Privacy Policy")}
									</ToSLink>.
								</p>
							</PolicyUpdate>
						</AcceptTerms>
					);
				} else if(!store.user.facebook.isConnected && !store.user.apple.isConnected){
					content = (
						<Login/>
					);
				}
			}
		}
		return (
			<Body>
				<LogoBox>
					<Logo alt="shake it up logo" src="/assets/splash/logo.png"/>
				</LogoBox>
				<Content>
					{content}
				</Content>
				<Copy>{i18n.t('copyright')}</Copy>
			</Body>
		)
	}
}
